import { BrowserRouter, Route, Switch } from "react-router-dom"
import routes from './routes'
import Footer from './components/navigation/Footer'
import Error404 from './pages/Error/404'

export default function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        {routes.map(({ path, name, Component, roles }, key) => (
          <Route
            exact
            path={path}
            key={key}
            render={props => {
              props.roles = roles
              const crumbs = routes
                .filter(({ path }) => props.match.path.includes(path))
                .map(({ path, ...rest }) => ({
                  path: Object.keys(props.match.params).length
                    ?
                    Object.keys(props.match.params).reduce(
                      (path, param) =>
                        path.replace(`:${param}`, props.match.params[param]),
                      path
                    )
                    :
                    path,
                  ...rest
                }))
              return (<Component {...props} crumbs={crumbs} />)
            }}
          />
        ))
        }
        <Route path="*" component={Error404} />
      </Switch>
      {
        /*
        // Para utilizar o rodapé com o número da versão do sistema, descomente a linha abaixo.
        // O rodapé será exibido em todas as páginas, exceto na página de login.
        <Footer /> 
        */
      }
    </BrowserRouter>
  )
}